<template>
  <v-container :fluid="true" class="ma-0 pa-0 bg-light-blue">
    <Partners
        v-if="$route.name === names.PARTNER.PAGE"
    />
    <router-view v-else />
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import Partners from "@/modules/personal_account/partners/pages/Partners.vue"
import names from "@/modules/personal_account/routers/names"

export default defineComponent({
  name: "PartnersBase",
  computed: {
    names () {
      return names
    }
  },
  components: { Partners }
})
</script>

<style scoped lang="scss">

</style>
